import { LoadingOutlined } from "@ant-design/icons";
import { Space } from "antd";

export interface LoadingPropsType {
  text?: string;
}
const Loading = ({ text }: LoadingPropsType) => {
  return (
    <div
      style={{
        height: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Space>
        <span>{text}</span>
        <LoadingOutlined />
      </Space>
    </div>
  );
};
export default Loading;
